import React from 'react';
import Routes from './routes';

import '../src/assets/styles/global.css';

function App() {
    return (
        <div>
            <Routes />
        </div>
    )
}

export default App;